import * as React from 'react';
import FilterItemTextComponent from "./filter-item-text";
import FilterDropdownTextComponent from "./filter-dropdown-text";
import { FindAPDAppState } from "../../classes/redux-states";
import { connect } from "react-redux";

interface StateToProps {
    countries: string[];
}

export class FiltersPanelAdv extends React.Component<StateToProps, any> {
	constructor(props) {
		super(props);
    }

    getStateList() {
        var stateList = [
            "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY", "LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"
        ]
        return stateList;
    }


	render() {
		return (
            <div className="find-a-pd-filters-panel">
                <FilterItemTextComponent filterName="lastName" filterLabel="Last Name" placeholderText="Enter last name here" />
                <FilterItemTextComponent filterName="city" filterLabel="City" placeholderText="Enter city here" />
                <FilterDropdownTextComponent filterLabel="State" filterName="state" placeholderText="Select a State" data={this.getStateList()} />
                <FilterDropdownTextComponent filterLabel="Country" filterName="country" placeholderText="Select a country" data={this.props.countries} /> 
			</div>
		)
	}
}

function mapStateToProps(state: FindAPDAppState): StateToProps {
    return {
        countries: state.findAPDSettingsModel.countries
    }
}
export default connect(mapStateToProps, null)(FiltersPanelAdv);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filters-panel-advanced.tsx